import { Interface } from '@ethersproject/abi';
import HYPER_DEX_ROUTER_ABI from './hyper-dex-router.json';

const HYPER_DEX_ROUTER_INTERFACE = new Interface(HYPER_DEX_ROUTER_ABI);

export { HYPER_DEX_ROUTER_ABI, HYPER_DEX_ROUTER_INTERFACE };
